import { Badge } from "@learn-me/ui";
import { CheckCircle, XCircle } from "lucide-react";

interface StudentStatusBadgeProps {
  isActive: boolean;
}

export function StudentStatusBadge({ isActive }: StudentStatusBadgeProps) {
  if (isActive) {
    return (
      <Badge
        variant="default"
        className="bg-green-100 text-green-800 hover:bg-green-100"
      >
        <CheckCircle className="h-3 w-3 mr-1" />
        Activo
      </Badge>
    );
  }

  return (
    <Badge
      variant="secondary"
      className="bg-red-100 text-red-800 hover:bg-red-100"
    >
      <XCircle className="h-3 w-3 mr-1" />
      Inactivo
    </Badge>
  );
}
